import React from 'react';
import { Box } from '../../../base/Box/Box';
import { Type } from '../../../base/Type/Type';
import classNames from 'classnames';
import isDarkColour from '../../../utils/isDarkColour';

type Props = {
  filter: string;
  colourScheme?: string;
  setOpen: (open: string) => void;
  setFilterState: (filter: object) => void;
  property: string;
};

export const Option = ({
  setFilterState,
  property,
  setOpen,
  colourScheme,
  filter,
}: Props) => {
  const onClick = (event: any) => {
    const rawValue = event.target.innerText as string;
    if (!rawValue) {
      return;
    }

    const cleanedValue = rawValue.toLowerCase().replace(' ', '');

    setFilterState((previous: object) => ({
      ...previous,
      [property]: cleanedValue,
    }));
    setOpen('');
  };

  return (
    <Box
      as="div"
      role="button"
      className={classNames('w-full cursor-pointer hover:opacity-80')}
      onClick={onClick}
    >
      <Type
        as="span"
        className={classNames(
          'm-0 p-0 font-foundersGrotesk text-lg',
          isDarkColour(colourScheme) ? 'text-white' : 'text-ffBlack'
        )}
      >
        {filter}
      </Type>
    </Box>
  );
};
